import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';

import { UppercasePipe } from './pipes/uppercase.pipe';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { DateformatPipe } from './pipes/dateformat.pipe';

import { JwtInterceptor } from './auth/jwt.interceptor';
import { ErrorInterceptor } from './services/error.interceptor';
import { SharedModule } from './shared/shared.module';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastContainerModule, ToastrModule } from 'ngx-toastr';
import { PageHomeComponent } from './components/page-home/page-home.component';
import { LoginPageComponent } from './components/login-page/login-page.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { PageDashboardComponent } from './components/page-dashboard/page-dashboard.component';
import { UserPanelComponent } from './components/user-panel/user-panel.component';
import { UserModule } from './users/user.module';
import { RoleModule } from './roles/role.module';
import { ResetPasswordRequestFormComponent } from './components/reset-password-request-form/reset-password-request-form.component';
import { ResetPasswordFormComponent } from './components/reset-password-form/reset-password-form.component';
import { ResetPasswordPageComponent } from './components/reset-password-page/reset-password-page.component';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    LoginPageComponent,
    AppComponent,
    UppercasePipe,
    CapitalizePipe,
    DateformatPipe,
    SidebarComponent,
    PageHomeComponent,
    PageDashboardComponent,
    UserPanelComponent,
    ResetPasswordRequestFormComponent,
    ResetPasswordFormComponent,
    ResetPasswordPageComponent
  ],

  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ToastrModule.forRoot(),
    ToastContainerModule,
    // NoopAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
    }),
    SharedModule,
    UserModule.forRoot(),
    RoleModule.forRoot()
  ],
  providers: [
    DateformatPipe,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { 
  constructor(private translate: TranslateService) {
    const savedLang = localStorage.getItem('lang');
  const browserLang = translate.getBrowserLang();
  const supportedLangs = ['it', 'en'];

  const langToUse = savedLang
    ? savedLang
    : supportedLangs.includes(browserLang)
      ? browserLang
      : 'en';

  this.translate.setDefaultLang(langToUse);
  this.translate.use(langToUse);
  }
}
